module.exports = __webpack_public_path__ + "assets/ic-newsbtc.54429190.svg";